import { apiAuth, apiFile } from './fetch.js'

// 上傳圖片API
const apiUploadImage = async (payload) => {
    // 修改 payload
    payload.append('source', 'optimize99');

    // 呼叫 API
    const resp = await apiFile('POST', '/img/pic/compress', payload, 'file_cdn');

    // 處理回應
    return `${process.env.VUE_APP_IMG_CDN_ENDPOINT}${resp.data.location || resp.data.ori}`;
};


const apiGetImageGallery = async (params) => {
    const data = {
        source: params.source,
        category: params.category,
        group_id: params.group_id || null,
        page: params.page || null,
        limit: params.limit || null,
        name: params.name || null
    }
    const url = '/img/pic/getImageLists'
    return (await apiAuth('GET', url, data, 'file_cdn')).data
}

const apiDeleteImage = async (params) => {
    const data = { id: params }
    const url = 'img/pic/deleteImage?'
    await apiAuth('DELETE', url, data, 'file_cdn')
}

const apiUploadFile = async (payload) => {

    // 修改 payload
    if (!payload['source']) {
        payload['source'] = 'optimize99'
    }

    // 呼叫 API
    const resp = await apiFile('POST', '/img/fileapi/upload', payload, 'file_cdn');

    // 處理回應
    return resp.data.data;
};
const apiDeleteFile = async (container_id, url) => {

    // 呼叫 API
    const resp = await apiAuth(
        'DELETE',
        `/img/fileapi/delete/url?category=${container_id}&source=optimize99&url=${url}`,
        '',
        'file_cdn'
    );

    // 處理回應
    return resp.data;
};


export {
    apiUploadImage,
    apiGetImageGallery,
    apiDeleteImage,
    apiUploadFile,
    apiDeleteFile
}